import { Component, OnInit, Inject, ElementRef, Input, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { staticInOut } from '../router.animations';
import { Subscription } from 'rxjs/Subscription';
import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ng2-page-scroll';
import { NavigationService } from '../navigation.service';
import { DOCUMENT } from '@angular/platform-browser';
import { appConfig } from './../app.config';
import { filter, forEach, groupBy, values, map, orderBy, compact } from 'lodash';
import * as Player from "@vimeo/player/dist/player.js";
import * as penner from '../penner.easing';;
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import * as imagesLoaded from 'imagesloaded';

@Component({
  selector: 'app-three-col-view',
  templateUrl: './three-col-view.component.html',
  styleUrls: ['./three-col-view.component.scss'],
  host: {
    '[@staticInOut]': ''
  },
  animations: [
    staticInOut,
    trigger('fadeInShow', [
      state('hidden', style({
        opacity: '0',
        visibility: 'hidden'
      })),
      state('visible',   style({
        opacity: '1',
        visibility: 'visible'
      })),
      transition('hidden => visible', animate('250ms ease-in'))
    ]),
    trigger('fadeInOut', [
      state('hide', style({
        opacity: '0'
      })),
      state('show',   style({
        opacity: '1'
      })),
      transition('hide => show', animate('250ms ease-in')),
      transition('show => hide', animate('250ms ease-out'))
    ])
  ]
})
export class ThreeColViewComponent implements OnInit {
  @Input() apiData;
  @Input() isLoadingApiData;
  public imageSrcBase = appConfig.imageUrl;
  public isLoaded = false;
  title: string;
  columns: any[];
  navigationSubscription: Subscription;

  @ViewChildren('vimeo') public vimeoElRefs: QueryList<ElementRef>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageScrollService: PageScrollService,
    private elRef: ElementRef,
    private NavigationService: NavigationService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };

    this.navigationSubscription = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((val) => {
      this.scrollToSection();
    });
  }
  
  trackItem(index, item) {
    return item ? item.id : undefined;
  }

  animationDone($event, block) {
    if ($event.toState === 'hide') {
      block.is_expanded = block.isExpanding;

      setTimeout(() => {
        if (block.is_expanded) {
          block.contentState = 'show';
        } else {
          block.linkState = 'show';
        }
      });
    }
  }

  expand(block) {
    block.isExpanding = true;
    setTimeout(() => {
      block.linkState = 'hide';
    });
  }

  minimise(block) {
    block.isExpanding = false;
    setTimeout(() => {
      block.contentState = 'hide';
    });
  }

  ngOnInit() {
    PageScrollConfig.defaultDuration = 0;
    PageScrollConfig.defaultEasingLogic.ease = penner.easeInQuad;
    setTimeout(() => {
      this.scrollToSection();
      PageScrollConfig.defaultDuration = 1000;
    }, 1000);
    
    let expandableBlocks = filter(this.apiData.cols, {type: 'expandable'});
    forEach(expandableBlocks, (block: any) => {
      block.linkState = !block.is_expanded ? 'show' : 'hide';
      block.contentState = block.is_expanded ? 'show' : 'hide';
    })
    let columnsGroupedObj = groupBy(this.apiData.cols, 'col');
    let columnsArr = values(columnsGroupedObj);
    columnsArr = map(columnsArr, (column) => {
      column = orderBy(column, ['position'], ['asc']);
      return column;
    });

    while (columnsArr.length < 3) {
      columnsArr.push([]);
    }

    this.title = this.apiData.title;
    this.columns = columnsArr;

    let vimeoUrls = [];
    forEach(this.columns, (column) => {
      vimeoUrls = vimeoUrls.concat(compact(map(column, 'video_url')));
    });

    setTimeout(() => {
      if (typeof this.vimeoElRefs !== 'undefined') {
        forEach(this.vimeoElRefs.toArray(), (vimeoElRef, i) => {
          var options = {
            url: vimeoUrls[i],
            width: 1280
          };
          let player = new Player(vimeoElRef.nativeElement, options);
        });
      }
    });

    imagesLoaded(this.elRef, ( instance ) => {
      setTimeout(() => {
        this.isLoaded = true;
      }, 1000);
    });
  }

  scrollToSection() {
    if (typeof this.NavigationService.navbarHeight !== 'undefined') {
      PageScrollConfig.defaultScrollOffset = this.NavigationService.navbarHeight;
    }
    let section = this.route.snapshot.params['section'];
    if (typeof section !== 'undefined') {
      let scrollContainer = document.body;
      let pageScrollInstance: PageScrollInstance = PageScrollInstance.newInstance({document: this.document, scrollTarget: `#${section}`, scrollingViews: [scrollContainer]});
      this.pageScrollService.start(pageScrollInstance);
    }
  }

  ngOnDestroy() {
    this.navigationSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/three-col-view/three-col-view.component.ts